/**
 * Shared constants + formatting helpers for the six costing sub-cards
 * mounted on the Project Detail page. Extracted from the monolithic
 * ProjectDetail.jsx for maintainability.
 */

export const FIELD =
  "w-full bg-white border border-slate-300 rounded-sm p-2 text-sm " +
  "focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none";

/** Format any numeric value as an INR string. Fraction digits are
 *  configurable so per-project cards can round to whole rupees while
 *  per-line rows can still show paise. */
export const inr = (v, maxFrac = 2) =>
  `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: maxFrac })}`;

/** Traffic-light margin tone. Mirrors the same thresholds used on the
 *  full Costing/Margin dashboard, so a project reads the same colour
 *  in the sidebar card as in the portfolio-wide table. */
export const marginTone = (pct) => {
  if (pct >= 25) return { color: "#15803d", bg: "#dcfce7", label: "Healthy" };
  if (pct >= 10) return { color: "#c2410c", bg: "#ffedd5", label: "Tight" };
  if (pct >= 0)  return { color: "#a16207", bg: "#fef3c7", label: "Low" };
  return { color: "#b91c1c", bg: "#fee2e2", label: "Loss" };
};
